var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCloneCalendarOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "blank-calendar 1",
    clipPath: "url(#clip0_3298_2080)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73692 2.11502V1.30751V0.5H4.32847H4.92002V1.30751V2.11502H7.99983H11.0796V1.30751V0.5H11.6712H12.2627V1.30751V2.11502H14.0937H15.9247V9.30751V9.48697L14.7416 8.34612V6.96009H7.99983H1.25805V11.1385V15.3169H7.99983H14.7416V13.9872L15.9247 12.8464V16.5H7.99983H0.0749512V9.30751V2.11502H1.90594H3.73692ZM1.25805 5.777V4.53756V3.29812H7.99983H14.7416V4.53756V5.777H7.99983H1.25805Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1255 8.2392L11.7199 8.64514L12.6715 9.59656C13.1948 10.1199 13.623 10.5543 13.623 10.5621C13.623 10.5698 10.4117 10.5761 8.00001 10.5761L8.00001 11.733C10.4117 11.733 13.623 11.7393 13.623 11.747C13.623 11.7548 13.1948 12.1892 12.6715 12.7125L11.7199 13.664L12.1255 14.0699C12.3486 14.2932 12.5396 14.4758 12.55 14.4758C12.5604 14.4758 13.3161 13.7286 14.2294 12.8152L15.89 11.1546L14.2294 9.4939C13.3161 8.58054 12.5604 7.83325 12.55 7.83325C12.5396 7.83325 12.3486 8.01592 12.1255 8.2392Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3298_2080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloneCalendarOutline);
export default __webpack_public_path__ + "static/media/icon--clone-calendar-outline.07f3570eb1554d225c54f0b73fa1f7a2.svg";
export { ForwardRef as ReactComponent };